import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#tasks_svg__a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M16 0a4 4 0 0 1 4 4v.414a6.6 6.6 0 0 0-3.593-.376l-10.404 1.8c-1.656.286-3.136 1.182-4.115 2.491S.51 11.253.78 12.82l.68 3.933c.209 1.203.8 2.3 1.682 3.154A4 4 0 0 1 0 16V4a4 4 0 0 1 4-4zm-5.685 12.183 2.08-.36.341 1.966-2.082.36.341 1.967-2.08.36-.342-1.966-2.079.36-.34-1.968 2.08-.36-.34-1.967 2.08-.36zm9.003 2.494-2.08.36-.34-1.968 2.08-.359zm-2.76-3.575-2.081.36-.34-1.967 2.08-.36z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "tasks_svg__a" }, [
        _createElementVNode("path", { d: "M0 0h20v20H0z" })
      ])
    ], -1)
  ])))
}
export default { render: render }